@if (over().length > 0) {
  <p-message severity="warn" styleClass="w-full">
    <div class="text-sm">
      {{
        'ApPayment_ReceivedShortfall_Banner'
          | translateWF
            : 'One or more selected documents would pay more than has been received on their purchase order. Click the “Exceeds received” tag, or a document here, to see why.'
      }}
      <span class="ml-1">{{ 'ApPayment_ReceivedShortfall_SeeWhy' | translateWF: 'See why:' }}</span>
      @for (coverage of over(); track coverage.documentReference) {
        <p-button [label]="coverage.documentNumber ?? '—'" [link]="true" size="small" styleClass="p-0 ml-1" (click)="open(coverage)" />
      }
    </div>
  </p-message>
}
